module.exports = __webpack_public_path__ + "vue.png?5eb3eb98d4017993099695f57a5c93c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vue.png
// module id = 10
// module chunks = 0